import { Box, Typography } from '@mui/material';
import React from 'react';

type Props = {
  label: string;
  data: any;
};

export const FieldCard = ({ data, label }: Props) => (
  <Box sx={{ display: 'flex', gap: '1rem' }}>
    <Typography variant="subtitle2">{label} </Typography>
    <Typography variant="body2">{data} </Typography>
  </Box>
);
